import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StyleGuideComponent } from './style-guide.component';
import { DemoColorsComponent } from './components/demo-colors/colors.component';
import { DemoTypographyComponent } from './components/demo-typography/typography.component';
import { DemoGridComponent } from './components/demo-grid/grid.component';
import { DemoSpacingComponent } from './components/demo-spacing/spacing.component';
import { DemoAlertsComponent } from './components/demo-alerts/demo-alerts.component';
import { DemoButtonsComponent } from './components/demo-buttons/buttons.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { DemoLoaderComponent } from './components/demo-loader/demo-loader.component';
import { DemoToastersComponent } from './components/demo-toasters/demo-toasters.component';
import { DemoWelcomeComponent } from './components/demo-welcome/demo-welcome.component';
import { AlertComponent } from '../../../components/alert/alert.component';
import { DemoFormComponent } from './components/demo-form/demo-form.component';
import { DemoModalComponent } from './components/demo-modal/demo-modal.component';
import { DemoTableComponent } from './components/demo-table/demo-table.component';
import { DemoGuideMenuComponent } from './components/_demo-guide-menu/demo-guide-menu.component';
import { DemoScreenViewComponent } from './components/demo-screen-view/demo-screen-view.component';
import { CopyElementComponent } from './components/copy-element/copy-element.component';
import { DemoGlobalMessageComponent } from './components/demo-global-message/demo-global-message.component';
import { DemoCollapseListComponent } from './components/demo-collapse-list/demo-collapse-list.component';
import { DemoToggleTextComponent } from './components/demo-toggle-text/demo-toggle-text.component';
import { DemoTableProComponent } from './components/demo-table-pro/demo-table-pro.component';

@NgModule({
  declarations: [
    StyleGuideComponent,
    DemoColorsComponent,
    DemoTypographyComponent,
    DemoGridComponent,
    DemoSpacingComponent,
    DemoAlertsComponent,
    DemoButtonsComponent,
  ],
  imports: [
    CommonModule,
    DemoWelcomeComponent,
    DemoLoaderComponent,
    DemoToastersComponent,
    AlertComponent,
    DemoFormComponent,
    DemoCollapseListComponent,
    DemoToggleTextComponent,
    DemoModalComponent,
    DemoTableComponent,
    DemoGuideMenuComponent,
    DemoScreenViewComponent,
    CopyElementComponent,
    DemoGlobalMessageComponent,
    DemoTableProComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        styleGuide: {
          component: StyleGuideComponent,
        },
      },
    }),
  ],
})
export class StyleGuideModule {}
